import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-object-type-group',
  templateUrl: './object-type-group.component.html',
  styleUrls: ['./object-type-group.component.css']
})
export class ObjectTypeGroupComponent implements OnInit {

  form: any | FormGroup
  editForm: any | FormGroup
  Data:any = []
  objectData: any = []
  singleStatusMaster: any= []
  deleteUomMasterId = ""
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  cid:any

  statusTypes = [
    'MDSTATUS'
  ]

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllObjectTypeAndGroup()
    this.form = this.fb.group({
      groupTypeList:this.fb.array([]),
    })
    this.editForm = this.fb.group({
      name: [''],
      description: [''],
      type:[''],
    })
    this.addGroupTypeList()
  }

  get groupTypeListForm(){
    return this.form.get('groupTypeList') as FormArray;
  }

  groupTypeListObject(){
    return this.fb.group({
      "group": "",
      "type": ""
    })
   }
  
   addGroupTypeList(){
    this.groupTypeListForm.push(this.groupTypeListObject())
   }

   removeGroupTypeList(index: number){
    this.groupTypeListForm.removeAt(index)
   }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllObjectTypeAndGroup();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllObjectTypeAndGroup();
  }

  addObjectTypeAndGroup(){
    //document.getElementById("submit").disabled = true;
    let body = {
      "cid": 0,
      "groupTypeList": this.form.get('groupTypeList').value,
    }
    
    console.log(body)
    this.generic_service.addObjectTypeAndGroup(body).subscribe(
      (response:any) => {
        console.log(response)
        this.getAllObjectTypeAndGroup()
        this.form.reset()
        this.cancelModel()
        this.toastr.success(response.message)
      },
      (error:any)=>{
        console.log(error)
      }
    )
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
  }

  getAllObjectTypeAndGroup(){
    this.generic_service.getAllObjectTypeAndGroup().subscribe(
      (res:any)=> {
        console.log(res)
        this.objectData = res.response.groupTypeList
      },
      (err:any)=>{
        console.log(err)
      }
    )
  }


// form.submit(function(){
//     form.submit(function(){
//         return false;
//     });
// });

}

